
import { Link, useNavigate } from "react-router-dom";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { InputDePassword } from '../../home/components';
import { useForm } from '../../../hooks';
import { useAuthStore, useCarritoClienteStore, useGlobalValueStore, useModalStore } from '../../../stores';
import { ModalFormulario } from "../../components";

import Swal from 'sweetalert2';
import { FormCrearUsuarioVenta } from "../../compras/components";
import { startCreateCuenta } from "../../../services";
const empresa = require.context('../../../assets/empresa', true);



export const LoginClientes = () => {


    const navigate = useNavigate();
    const { startLoginCliente } = useAuthStore();
    const { pageCliente } = useGlobalValueStore();
    const { items } = useCarritoClienteStore();
    const [ formAdmin, handleInputChangeA ] = useForm({ movil: '', password: '' });
    const { movil, password } = formAdmin;
    const { modalFormToggle } = useModalStore();
    


    
    const handleLogin = async(e) => {
        e.preventDefault();
        if (!movil?.trim() || !password?.trim()) {
            Swal.fire('Error', 'La cédula y la contraseña son obligatorias.', 'error');
            return;
        }
        
        const respuesta = await startLoginCliente({ movil, password, items });
        if ( respuesta ) {
            navigate(pageCliente || '/');
        }

        // e.preventDefault();
        // try {
        // const { data } = await axios.post(`${ baseUrl }/cliente/login`, formCliente);
        // if( data.ok ) {
        //     localStorage.setItem('tokenCliente', data.token);
        //     localStorage.setItem('token-init-cli', new Date().getTime());
        //     dispatch( authClienteChekingLogin({
        //         uid: data.uid,
        //         nombre: data.nombre,
        //         role: data.role,
        //         cliente: data.cliente,
        //     }));
        //     const Toast = Swal.mixin({
        //     toast: true,
        //     position: 'bottom-end',
        //     showConfirmButton: false,
        //     timer: 3000,
        //     timerProgressBar: true,
        //     didOpen: (toast) => {
        //         toast.addEventListener('mouseenter', Swal.stopTimer)
        //         toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     }
        //     })
        //     Toast.fire({
        //     icon: 'success',
        //     title: 'Inicio de Sección con Exito'
        //     });
        //     navigate(lastPath);
            
        //     if( !data.cliente.terminos ){
        //     Swal.fire({
        //         title: 'Importante',
        //         text: 'Debes Aceptar los Teminos y Condiciones',
        //         icon: 'info',
        //         footer: '<a class="enlace-termino" href="/terminos" target="_blank">Ver Terminos y Condiciones.</a>',
        //         allowOutsideClick: false,
        //         stopKeydownPropagation: true
        //     }).then((result) => {
        //         if (result.value) {
        //         Swal.fire('Guardado con Exito', '', 'success');
        //         dispatch( clienteUpdateTerminos({ terminos: true, id: data.uid }) );
        //         } 
        //     })
        //     }

        // } else {
        //     Swal.fire('Error', data.msg, 'error');
        // }
        // }catch (error){
        // console.log(error);
        // Swal.fire('Error', error.response.data.msg, 'error');
        // }
    }


    const handleCrearCuenta = async(formCliente) => {
        const resp = await startCreateCuenta({ ...formCliente, items });
        if( resp ){
            navigate(pageCliente || '/');
            return true;
        }
        return false;
    }




    return (
        <Grid container className="login-cliente">
            <Grid item className="img-cliente">
                <img src={ empresa(`./svtextoblanco.png`) } />
            </Grid>

            <Grid item>
                <Typography variant="h1" mt={3}>Login Cliente</Typography>
            </Grid>

            <Grid item xs={10} sx={{ width:'400px', padding:'20px' }}>
                <form onSubmit={ handleLogin } autoComplete="off" >

                    <Grid item xs={12} mt={2} >
                        <TextField required
                            label='Numero Telefono'
                            type='text'
                            placeholder='Numero Telefono'
                            fullWidth
                            name="movil" 
                            value={ movil }
                            onChange={ handleInputChangeA }
                            size='small'
                        />
                    </Grid>

                    <Grid item xs={12} mt={ 2 }>
                        <InputDePassword value={password}
                            name='password'
                            placeholder={'Password'} 
                            onChangeInput={ handleInputChangeA } 
                            size='small'
                        /> 
                    </Grid>

                    <Grid sx={{ width:"100%", display:"flex", flexDirection:{xs:"column", sm:"row"},
                        justifyContent:"space-between", alignItems:"center", gap:{xs:1.5, sm:0}, mt:4,
                    }}>
                        <Typography onClick={() => modalFormToggle(true)} to="/registro" sx={{ textDecoration:"none", 
                            fontSize:"0.90rem", fontWeight:500, transition:"all 0.2s ease", cursor:'pointer',
                            color:"text.secondary", "&:hover": {color:"primary.main", transform:"translateY(-1px)"},
                        }}>
                            ¿No tienes cuenta?{" "}
                            <Box component="span" sx={{ color:"primary.main", fontWeight:700 }}>
                                Regístrate
                            </Box>
                        </Typography>

                        {/* to="/admin/olvide-password" */}
                        <Typography component={Link} 
                            sx={{ textDecoration:"none", fontSize:"0.90rem", fontWeight:500, color:"text.secondary",
                            transition:"all 0.2s ease", "&:hover":{color:"secondary.main", transform:"translateY(-1px)"}
                        }}>
                            Olvidé mi contraseña
                        </Typography>
                    </Grid>

                    <Grid container sx={{ mt:2, mb:3, direccion:'column', justifyContent:'center'}}>
                        <Grid item xs={ 12 } >
                            <Button variant="contained" color="primary" fullWidth type="submit" >
                                <Typography variant="span" color='white' >Ingresar</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Grid>

            <ModalFormulario titulo="Crear Mi Cuenta" valor={{}} onClose={() => modalFormToggle(false)}>
                <FormCrearUsuarioVenta funcion={ handleCrearCuenta } />
            </ModalFormulario>
        </Grid>
    )
}
